import React from 'react';

import {
  useCheckMemberSharedOnly,
  useCheckIsSuperAdmin,
  useCheckIsSuperMember,
} from 'hooks';

const useCheckIsShowForSharedOnlyMember = () => {
  const isMemberSharedOnlyUser = useCheckMemberSharedOnly();
  const isSuperAdmin = useCheckIsSuperAdmin();
  const isSuperMember = useCheckIsSuperMember();

  if (isSuperMember || isSuperAdmin) {
    return true;
  }

  if (isMemberSharedOnlyUser) {
    return false;
  }

  return true;
};

const IsShowForSharedOnlyMemberWrap = ({ children, ...restProps }) => {
  const isShow = useCheckIsShowForSharedOnlyMember();

  const renderChildren = () => {
    if (!children) return null;

    return React.Children.map(children, (child) => {
      return child ? React.cloneElement(child, restProps) : null;
    });
  };

  return <> {isShow ? renderChildren() : null}</>;
};

export { useCheckIsShowForSharedOnlyMember, IsShowForSharedOnlyMemberWrap };
